module.exports = __webpack_public_path__ + "img/deposit.40271598.png";